import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { defaultSsgFormStyle, formElements, SsgFormComponent, ssgFormActions } from '@social-solutions/ssg-forms';
import optOutConfirmFormDef, { confirmOptOutElement } from './opt-out-confirm-form-definition';
import './opt-out-confirm-form.scss';

const formId = 'opt-out-form';

/**
 * Simple form with one radio element, allowing the user
 * to opt out of direct messages.
 */
export class OptOutConfirmForm extends Component {

  componentWillMount() {
    const { ssgFormActions } = this.props;
    // clear out the existing answers, just in case
    ssgFormActions.hardReset('opt-out-form');
  }

  /**
   * Handles confirming the user's choice. Only perform a true unsub if the user selected Yes
   * @param {FormState} formState used to check if validation has passed, along with the user's radio choice
   */
  handleFormSubmit(formState) {

    const { onHandleSubmit, redirectTo } = this.props;

    // User must take the red pill or the blue pill
    if (!formState.validationResult.passedValidation) {
      return;
    }

    // only make an API call if the user selected Yes
    const userChoice = formState.value.get(confirmOptOutElement.id);
    if (!!userChoice && userChoice.size === 1) {
      const userValue = userChoice.get(0);
      if (userValue === '1') {
        onHandleSubmit();
      }
    }

    // User will land at generic text page
    redirectTo('/confirmed');
  }

  render() {
    const { title } = this.props;

    // set unique form elements styles
    var passwordStyle = Object.assign({}, formElements.defaultElementStyles.specialText);
    passwordStyle.label += " opt-out-confirm-input-label";
    var formElementStyles = Object.assign({}, formElements.defaultElementStyles);
    formElementStyles.specialText = passwordStyle;

    // set form style
    var formStyle = {
      actions: defaultSsgFormStyle.actions + " opt-out-confirm-action-bar",
      primaryButton: defaultSsgFormStyle.primaryButton + " opt-out-confirm-form-button",
      title: defaultSsgFormStyle.title += " opt-out-confirm-header",
    };

    var formDefWithTitle = optOutConfirmFormDef;
    formDefWithTitle.name = title ? title : "Confirmation";

    const formProps = {
      id: formId,
      form: formDefWithTitle,
      disableValidationResultList: true,
      buttonLayout: [
        {
          id: "opt-out-submit",
          type: "submit",
          display: "SUBMIT",
          ariaLabel: "submit",
          buttonType: "primary",
          functionType: "submit",
          onClick: (state) => this.handleFormSubmit(state)
        }
      ],
      elementStyles: formElementStyles,
      css: formStyle
    }

    return (
      <div id="opt-out-confirm-form">
        <SsgFormComponent {...formProps}/>
      </div>
    )
  }
}

OptOutConfirmForm.propTypes = {
 title: PropTypes.string,
 onHandleSubmit: PropTypes.func,
};

const mapStateToProps = () => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
 return {
   redirectTo: bindActionCreators(push, dispatch),
   ssgFormActions: bindActionCreators(ssgFormActions, dispatch)
 }
}

export default connect(mapStateToProps, mapDispatchToProps)(OptOutConfirmForm);



// WEBPACK FOOTER //
// src/acct/opt-out/opt-out-confirm-form.js